import { render } from "./IssueSwift.vue?vue&type=template&id=5810a974&scoped=true"
import script from "./IssueSwift.vue?vue&type=script&lang=js"
export * from "./IssueSwift.vue?vue&type=script&lang=js"

import "./IssueSwift.vue?vue&type=style&index=0&id=5810a974&scoped=true&lang=css"
import "./IssueSwift.vue?vue&type=style&index=1&id=5810a974&scoped=true&lang=scss"
import "./IssueSwift.vue?vue&type=style&index=2&id=5810a974&lang=scss"
import "./IssueSwift.vue?vue&type=style&index=3&id=5810a974&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5810a974"]])

export default __exports__